import request from '@/utils/request'
import setting from '@/settings'
import qs from 'qs'
const apiUrl = setting.apiUrl

/**
 * 获取个人信息
 * @param data
 */
export const getPersonInfo = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/getUserById`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 更新 个人信息
 * @param data
 */
export const updatePersonInfo = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/updateUserInfo`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取系统操作日志
 * @param data
 */
export const getOperaLogList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/req/log/list`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取日志信息详情
 * @param data
 */
export const getOperaLogInfo = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/req/log/info`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取用户列表
 * @param data
 */
export const lbCompanyUserList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/searchCompanyUser`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取用户总条数
 * @param data
 */
export const lbCompanyUserCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/user/searchCompanyUserCount`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取协议内容
 * @param data
 */
export const getProtocolInfo = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/serviceAgreement/selectOneByType`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 编辑协议内容
 * @param data
 */
export const updateProtocolInfo = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/serviceAgreement/edit`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取协议版本记录
 * @param data
 */
export const getProtocolHistory = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/serviceAgreement/getHistoryList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取协议版本记录内容
 * @param data
 */
export const getProtocolHistoryInfo = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/serviceAgreement/selectOneById`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取用户权限配置列表
 * @param data
 */
export const getUserAuthList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/power/list`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取用户权限配置列表总数
 * @param data
 */
export const getUserAuthListCount = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/power/list/count`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 新增用户授权配置
 * @param data
 */
export const insertUserAuth = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/power/insert`,
    method: 'post',
    data
  })

/**
* 用户权限配置回显详情
* @param data
*/
export const getUserAuth = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/power/getPower`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 更新用户授权配置
 * @param data
 */
export const updateUserAuth = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/power/update`,
    method: 'post',
    data
  })

/**
* 删除用户权限配置
* @param data
*/
export const deleteUserAuthById = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/power/delete`,
    method: 'post',
    data: qs.stringify(data)
  })
